<p>notification-template-sms-list works!</p>
